module.exports = __webpack_public_path__ + "img/Slice6en-min.6b68b857.png";